<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    let website_en_url;
    axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/config/configKey/website_en_url`,).then(response => {
      var res = response.data
      if(res.code == 200){
          website_en_url = res.data;
          console.log('url', website_en_url)
      }else{
          // this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
      }
    }).catch(error=>{
        console.log(error)
    })
    var lang = navigator.language || navigator.userLanguage; //常规浏览器laught和IE浏览器
    lang = lang.substr(0, 2); //截取lang前2位字符
    if (lang == 'zh') {
        localStorage.setItem('lang','zh');
    } else {
        localStorage.setItem('lang','en');
        // window.location.href = 'http://en.decard.com';
        window.location.href = website_en_url;
    }
  },
  methods:{
    

  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue